export default "__VITE_ASSET__BIR$rbcO__"